import { render, staticRenderFns } from "./FormMenusAdd.vue?vue&type=template&id=28b7105c&scoped=true&"
import script from "./FormMenusAdd.vue?vue&type=script&lang=js&"
export * from "./FormMenusAdd.vue?vue&type=script&lang=js&"
import style0 from "./FormMenusAdd.vue?vue&type=style&index=0&id=28b7105c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b7105c",
  null
  
)

export default component.exports